const KEY = 'tark.squad-invite.v2';
const TTL = 30 * 60 * 1000;
type Intent = { reference: string; userId: string | null; expiresAt: number };
export function inviteErrorCode(error: unknown): string | undefined {
  const data = (error as { response?: { data?: { errorCode?: string; code?: string; error?: string } } })?.response?.data;
  return data?.errorCode ?? data?.code ?? data?.error;
}
export function keepInvite(reference: string, userId: string | null): boolean {
  if (!/^[A-Za-z0-9_-]{4,128}$/.test(reference)) return false;
  try {
    const raw = sessionStorage.getItem(KEY);
    const existing: Intent | null = raw ? JSON.parse(raw) : null;
    if (existing?.reference === reference) {
      if (!Number.isFinite(existing.expiresAt) || existing.expiresAt <= Date.now() || existing.expiresAt > Date.now() + TTL
        || (existing.userId !== null && existing.userId !== userId)) return false;
      if (existing.userId === null && userId) sessionStorage.setItem(KEY, JSON.stringify({ ...existing, userId }));
      return true;
    }
    sessionStorage.setItem(KEY, JSON.stringify({ reference, userId, expiresAt: Date.now() + TTL }));
    return true;
  } catch { return false; }
}
export function clearInvite(reference: string): void {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (raw && JSON.parse(raw)?.reference === reference) sessionStorage.removeItem(KEY);
  } catch { /* Storage failure does not grant membership or extend the deadline. */ }
}
